import { render } from "./Eventcontent.vue?vue&type=template&id=723e2386"
import script from "./Eventcontent.vue?vue&type=script&lang=js"
export * from "./Eventcontent.vue?vue&type=script&lang=js"

import "./Eventcontent.vue?vue&type=style&index=0&id=723e2386&lang=css"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__